import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { LinearProgress, Box } from '@mui/material';

const RouteLoader = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 200); // Short delay for smooth UX
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && (
        <Box sx={{ position: 'fixed', top: 64, left: 0, right: 0, zIndex: 1301 }}>
          <LinearProgress />
        </Box>
      )}
      <Box sx={{ opacity: loading ? 0.7 : 1, transition: 'opacity 0.2s' }}>
        {children}
      </Box>
    </>
  );
};

export default RouteLoader;